
import { Users, UserCheck, Clock, Star, BarChart2 } from 'lucide-react';

interface DashboardSummaryProps {
  stats: {
    totalCandidates: number;
    newCandidates: number;
    shortlisted: number;
    reviewed: number;
    rejected: number;
    averageScore: number;
  };
}

const DashboardSummary = ({ stats }: DashboardSummaryProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Total Candidates */}
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-sm font-medium text-apple-text-secondary mb-1">
              Total Candidates
            </div>
            <div className="text-3xl font-semibold text-apple-text">
              {stats.totalCandidates}
            </div>
          </div>
          <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-apple-blue">
            <Users size={24} />
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-100 flex items-center text-sm text-apple-text-secondary">
          <Clock size={16} className="mr-1.5" />
          <span>{stats.newCandidates} new in the last week</span>
        </div>
      </div>

      {/* Shortlisted */}
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-sm font-medium text-apple-text-secondary mb-1">
              Shortlisted Candidates
            </div>
            <div className="text-3xl font-semibold text-apple-text">
              {stats.shortlisted}
            </div>
          </div>
          <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center text-green-500">
            <Star size={24} />
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-100 flex items-center text-sm text-apple-text-secondary">
          <UserCheck size={16} className="mr-1.5" />
          <span>{Math.round((stats.shortlisted / stats.totalCandidates) * 100)}% of total candidates</span>
        </div>
      </div>

      {/* Average Score */}
      <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-sm font-medium text-apple-text-secondary mb-1">
              Average Assessment Score
            </div>
            <div className="text-3xl font-semibold text-apple-text">
              {stats.averageScore}%
            </div>
          </div>
          <div className="w-12 h-12 rounded-full bg-purple-50 flex items-center justify-center text-purple-500">
            <BarChart2 size={24} />
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-100">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div 
              className="h-full bg-purple-500 rounded-full"
              style={{ width: `${stats.averageScore}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSummary;
